export default {
  views: {
    welcome: {
      title: "Pridružite se mreži Fractional Executive",
      description: "Competo povezuje izkušene vodstvene kadre s podjetji, ki potrebujejo C-level podporo za del delovnega časa. Vaš profil je osnova za povezovanje s primernimi priložnostmi.",
      points: {
        profile: "Izpolnite strukturiran profil v devetih korakih - kompetence, dokazani rezultati, razpoložljivost in cenovni okvir.",
        experience: "Dodajte ključna podjetja in funkcije iz svoje karierne poti.",
        documents: "Naložite svoj CV in ga kadarkoli zamenjajte z novejšim.",
        privacy: "Profil vidi le ekipa Competo. Cenovni okvir ni viden podjetjem."
      },
      note: "Profil lahko izpolnjujete postopoma - vsak korak lahko shranite in se vrnete kasneje.",
      start_button: "Začnite svoj fractional profil",
      dead_end: {
        title: "Ta portal ni namenjen vašemu računu",
        description: "Portal Fractional Executive je namenjen kandidatom. Vaš račun ni povezan s kandidatnim profilom, zato tukaj ni ničesar za urejanje. Če menite, da gre za napako, nam pišite.",
        portal_button: "Odprite kandidatni portal"
      },
      notify: {
        enabled: "Vaš fractional profil je pripravljen.",
        error: "Profila ni bilo mogoče pripraviti."
      }
    },
    experience: {
      title: "Delovne izkušnje",
      description: "Ključna podjetja in funkcije iz vaše karierne poti. V koraku Reference izberete tiste, ki jih želite posebej izpostaviti.",
      empty: "Dodajte prvo delovno izkušnjo.",
      buttons: {
        add: "Dodaj izkušnjo",
        edit: "Uredi",
        remove: "Izbriši",
        cancel: "Prekliči"
      },
      table: {
        job_title: "Funkcija",
        company_name: "Podjetje",
        period: "Obdobje",
        current: "danes"
      },
      popup: {
        add_title: "Nova delovna izkušnja",
        edit_title: "Urejanje delovne izkušnje",
        add_button: "Dodaj",
        update_button: "Shrani",
        fields: {
          job_title: "Funkcija",
          job_title_placeholder: "npr. Finančni direktor",
          company_name: "Podjetje",
          company_name_placeholder: "npr. Acme d.o.o.",
          work_start_date: "Začetek",
          date_placeholder: "dd.mm.llll",
          work_end_date: "Konec",
          current_employer: "Tu delam še danes",
          experience_in_company: "Opis dela in dosežkov",
          experience_in_company_placeholder: "npr. Vodenje finančne ekipe petih ljudi, prenova kontrolinga, priprava na prevzem."
        }
      },
      prompts: {
        delete: {
          title: "Izbris izkušnje {title}",
          message: "Ste prepričani, da želite izbrisati delovno izkušnjo {title}?",
          cancel: "Prekliči",
          confirm: "Izbriši"
        }
      },
      notify: {
        saved: "Delovna izkušnja je shranjena.",
        removed: "Delovna izkušnja je izbrisana.",
        load_error: "Delovnih izkušenj ni bilo mogoče naložiti.",
        error: "Delovne izkušnje ni bilo mogoče shraniti."
      }
    },
    documents: {
      title: "Dokumenti",
      description: "Vaš CV je izhodišče za pogovor s podjetji. Naložite najnovejšo različico.",
      empty: "Nimate naloženega CV-ja.",
      upload: "Naložite CV",
      replace: "Zamenjajte CV",
      hint: "Sprejemamo datoteke PDF in Word (.docx). Nova datoteka nadomesti obstoječo.",
      dropzone: "<b>Izberite datoteko</b> ali jo povlecite sem",
      dropzone_overlay: "Spustite datoteko za nalaganje",
      table: {
        name: "Naziv"
      },
      buttons: {
        remove: "Izbriši",
        change: "Zamenjaj"
      },
      status: {
        uploading: "Nalaganje",
        completed: "Naloženo",
        error: "Napaka"
      },
      prompts: {
        delete: {
          title: "Izbris datoteke {name}",
          message: "Ste prepričani, da želite izbrisati datoteko {name}?",
          cancel: "Prekliči",
          confirm: "Izbriši"
        }
      },
      notify: {
        uploaded: "CV je naložen.",
        removed: "Datoteka je izbrisana.",
        load_error: "Dokumentov ni bilo mogoče naložiti.",
        error: "Datoteke ni bilo mogoče shraniti."
      },
      proofs: {
        title: "Dokazila",
        description: "Priložite dokazila, ki podpirajo vaš profil - priporočila, potrdila o doseženih rezultatih, certifikate.",
        empty: "Nimate naloženih dokazil.",
        upload: "Dodajte dokazilo",
        hint: "Sprejemamo datoteke PDF, Word in slike (JPG, PNG) do 10 MB. Vsaka nova datoteka se doda k obstoječim.",
        table: {
          name: "Naziv"
        },
        buttons: {
          remove: "Izbriši"
        },
        notify: {
          uploaded: "Dokazilo je naloženo.",
          removed: "Datoteka je izbrisana.",
          load_error: "Dokazil ni bilo mogoče naložiti.",
          error: "Datoteke ni bilo mogoče shraniti."
        }
      }
    },
    profile: {
      title: "Evidenčni profil za Fractional Executive",
      description: "Izpolnite profil, da vas lahko povežemo z ustreznimi priložnostmi. Podatke lahko kadarkoli dopolnite.",
      eyebrow: "Fractional Executive",
      rail_note: "Profil lahko izpolnjujete postopoma - ob prehodu na naslednji korak se osnutek shrani sam.",
      steps_short: {
        basic: "Osnovni podatki",
        summary: "Povzetek",
        competences: "Ključne kompetence",
        results: "Dokazani rezultati",
        fractional_experience: "Fractional izkušnje",
        situations: "Situacije in vloge",
        availability: "Razpoložljivost",
        pricing: "Cenovni okvir",
        references: "Reference",
        leadership: "Stil vodenja"
      },
      steps_nav: "Koraki profila",
      progress: "Izpolnjeni koraki: {done} od {total}",
      status: {
        title: "Stanje",
        draft: "V pripravi",
        submitted: "Oddan v pregled",
        reviewed: "Pregledan"
      },
      steps_state: {
        filled: "(izpolnjeno)",
        empty: "(prazno)",
        invalid: "(potrebuje popravek)"
      },
      save_state: {
        saving: "Shranjujemo ...",
        unsaved: "Neshranjene spremembe",
        saved: "Shranjeno ob {time}"
      },
      errors: {
        summary: "Nekaj polj je treba popraviti, preden profil shranimo.",
        jump: "Pojdi na korak {step}"
      },
      repeater: {
        row: "vrstica {number}"
      },
      prompts: {
        unsaved: {
          title: "Neshranjene spremembe",
          message: "Sprememb ni bilo mogoče shraniti. Če zapustite stran, bodo izgubljene.",
          cancel: "Ostani na strani",
          confirm: "Zapusti stran"
        },
        remove_row: {
          title: "Odstranitev vnosa",
          message: "Ste prepričani, da želite odstraniti {name}?",
          cancel: "Prekliči",
          confirm: "Odstrani"
        }
      },
      buttons: {
        save: "Shrani",
        submit: "Oddaj v pregled",
        previous: "Nazaj",
        next: "Naprej",
        add: "Dodaj novega",
        remove: "Odstrani"
      },
      notify: {
        saved: "Profil je shranjen.",
        submitted: "Profil je oddan v pregled.",
        invalid: "Profila ni bilo mogoče shraniti - preverite označena polja.",
        error: "Profila ni bilo mogoče shraniti."
      },
      steps: {
        basic: "1. Osnovni podatki",
        summary: "2. Povzetek",
        competences: "3. Ključne kompetence",
        results: "4. Dokazani rezultati",
        fractional_experience: "5. Fractional izkušnje",
        situations: "6. Situacije in vloge",
        availability: "7. Razpoložljivost in geografija",
        pricing: "8. Cenovni okvir",
        references: "9. Reference in kredibilnost",
        leadership: "10. Stil vodenja"
      },
      basic: {
        description: "Kontaktni podatki in pravni status.",
        name: "Ime in priimek",
        name_placeholder: "npr. Ana Novak",
        email: "Elektronski naslov",
        email_info: "Naslov, s katerim ste prijavljeni. Za spremembo nam pišite.",
        phone: "Telefonska številka",
        phone_placeholder: "npr. +386 41 123 456",
        phone_info: "S klicno številko države, da vas dosežemo tudi iz tujine.",
        address: "Ulica in hišna številka",
        address_placeholder: "npr. Slovenska cesta 1",
        postal: "Poštna številka",
        postal_placeholder: "npr. 1000",
        city: "Mesto",
        city_placeholder: "npr. Ljubljana",
        country: "Država",
        country_placeholder: "npr. Slovenija",
        linkedin_url: "LinkedIn povezava",
        linkedin_url_placeholder: "https://www.linkedin.com/in/ime-priimek",
        linkedin_url_info: "Celotna povezava do vašega profila, ne samo uporabniško ime.",
        position_title: "Naziv delovnega mesta",
        position_title_placeholder: "npr. Finančni direktor",
        employer: "Trenutni delodajalec",
        employer_placeholder: "npr. Acme d.o.o.",
        legal_status: "Pravni status",
        legal_status_placeholder: "Izberite status",
        legal_status_info: "Oblika, prek katere bi sklenili sodelovanje.",
        legal_status_options: {
          sp: "s.p.",
          doo: "d.o.o.",
          employed: "Zaposlen",
          other: "Drugo"
        },
        legal_status_note: "Pojasnilo pravnega statusa",
        legal_status_note_placeholder: "npr. zaposlen s soglasjem delodajalca",
        languages: "Znanje jezikov",
        languages_hint: "Dodajte jezike, v katerih lahko vodite sestanke.",
        languages_empty: "Dodajte prvi jezik.",
        language_name: "Jezik",
        language_name_placeholder: "npr. Angleščina",
        language_level: "Nivo",
        language_level_placeholder: "Izberite nivo",
        language_levels: {
          a1: "A1 - začetnik",
          a2: "A2 - osnovno",
          b1: "B1 - srednje",
          b2: "B2 - višje",
          c1: "C1 - napredno",
          c2: "C2 - odlično",
          native: "Materni jezik"
        }
      },
      summary: {
        description: "Executive summary v 3-5 vrsticah.",
        headline: "Naslov profila",
        headline_placeholder: "npr. Turnaround CFO za srednje velika proizvodna podjetja",
        headline_info: "Ena vrstica, ki pove vlogo, panogo in vašo posebnost.",
        career_path: "Ključna karierna pot",
        career_path_placeholder: "npr. 15 let financ v proizvodnji, od kontrolinga do CFO v skupini s 300 zaposlenimi.",
        career_path_info: "2-3 stavki o tem, kje ste bili in kam ste prišli.",
        expertise_areas: "Glavna strokovna področja",
        expertise_areas_placeholder: "npr. Prestrukturiranje financiranja, kontroling, priprava na due diligence.",
        expertise_areas_info: "Naštejte 3-5 področij, kjer ste res doma.",
        value_creation: "Kje ustvarjate največjo vrednost",
        value_creation_placeholder: "npr. V prvih 100 dneh vzpostavim finančno preglednost in likvidnostni načrt.",
        value_creation_info: "Konkretno: kaj se v podjetju spremeni, ko vstopite."
      },
      competences: {
        description: "Funkcionalna področja, transformacijske kompetence in industrijske izkušnje.",
        workfields: "A. Funkcionalna področja",
        workfields_placeholder: "Izberite področja",
        workfields_info: "Področja, ki jih lahko prevzamete v celoti.",
        industries: "C. Industrijske izkušnje",
        industries_placeholder: "Izberite panoge",
        industries_info: "Panoge, kjer poznate posel in ne le funkcije.",
        transformation: "B. Transformacijske kompetence",
        transformation_hint: "Izberite vse, ki jih znate voditi, ne le tistih, ki ste jih videli od blizu.",
        transformation_empty: "Seznam kompetenc ni na voljo.",
        transformation_other: "Druge transformacijske kompetence",
        transformation_other_placeholder: "npr. Uvedba ESG poročanja",
        transformation_other_info: "Ločite jih z vejico, če jih je več."
      },
      results: {
        description: "Dokazani rezultati, po možnosti kvantificirani.",
        results: "Rezultati",
        results_hint: "Raje trije merljivi rezultati kot deset splošnih.",
        empty: "Dodajte prvi rezultat.",
        metric: "Kazalnik",
        metrics: {
          revenue_growth: "Rast prihodkov",
          ebitda_improvement: "Izboljšanje EBITDA",
          cost_reduction: "Znižanje stroškov",
          new_markets: "Vstop na nove trge",
          org_change: "Organizacijske spremembe",
          other: "Drugo"
        },
        value: "Vrednost",
        value_placeholder: "npr. 18",
        value_info: "Samo številka - enoto izberete v naslednjem polju.",
        unit: "Enota",
        units: {
          percent: "%",
          pp: "odstotne točke",
          eur: "EUR",
          text: "Brez enote"
        },
        result_description: "Opis",
        result_description_placeholder: "npr. Prenova nabave in pogajanja z dobavitelji so znižali stroške materiala.",
        company: "Podjetje",
        company_placeholder: "npr. Acme d.o.o.",
        period: "Obdobje",
        period_placeholder: "npr. 2021 - 2023",
        period_info: "Letnica ali razpon let, v katerem je bil rezultat dosežen.",
        reference_name: "Referenčna oseba (ime in priimek)",
        reference_name_placeholder: "npr. Janez Kranjc",
        reference_info: "Oseba, ki lahko potrdi navedeni uspeh. Vpišite jo le z njenim soglasjem.",
        reference_position: "Podjetje in pozicija, kjer ste sodelovali",
        reference_position_placeholder: "npr. Acme d.o.o., direktor",
        reference_contact: "Kontakt referenčne osebe",
        reference_contact_placeholder: "npr. janez.kranjc@acme.si ali 041 123 456"
      },
      fractional_experience: {
        description: "Vaše dosedanje izkušnje z delom v vlogi Fractional Executive in primeri sodelovanj, na katere se lahko sklicujemo.",
        has_experience: "Ali ste že delovali kot Fractional Executive?",
        has_experience_hint: "Štejejo tudi interim in part-time vodstvene vloge pri enem ali več podjetjih hkrati.",
        answers: {
          yes: "Da",
          no: "Ne"
        },
        engagements_count: "Koliko tovrstnih sodelovanj ste že izvedli?",
        engagements_count_placeholder: "npr. 3",
        engagements_count_info: "Število ločenih sodelovanj s podjetji, zaključenih ali v teku.",
        note: "Opis dosedanjih sodelovanj",
        note_placeholder: "npr. Večinoma podjetja v rasti med 50 in 200 zaposlenimi, v povprečju 2 dni na teden.",
        references: "Referenčni primeri",
        references_hint: "Sodelovanja, ki najbolje pokažejo, kaj prinesete podjetju. Kontakt referenčne osebe je neobvezen - vpišite ga le z njenim soglasjem.",
        references_empty: "Dodajte prvi referenčni primer.",
        reference_row: "referenčni primer",
        company: "Podjetje",
        company_placeholder: "npr. Acme d.o.o.",
        role: "Vloga",
        role_placeholder: "npr. Fractional CFO",
        period: "Obdobje",
        period_placeholder: "npr. 2022 - 2024",
        reference_description: "Obseg in rezultat sodelovanja",
        reference_description_placeholder: "npr. 2 dni na teden; vzpostavitev kontrolinga in priprava podjetja na prevzem.",
        contact_name: "Referenčna oseba",
        contact_name_placeholder: "npr. Janez Kranjc, direktor",
        contact_info: "Oseba, ki lahko potrdi sodelovanje.",
        contact: "Kontakt referenčne osebe",
        contact_placeholder: "npr. janez.kranjc@acme.si"
      },
      situations: {
        description: "Kje dodajate največ vrednosti in katere vloge so za vas primerne.",
        situations: "Tipične situacije",
        situations_hint: "Izberite vse, v katerih ste že vodili in bi jih prevzeli znova.",
        situations_empty: "Seznam situacij ni na voljo.",
        situations_other: "Druge situacije",
        situations_other_placeholder: "npr. Priprava na vstop na borzo",
        situations_other_info: "Za situacije, ki jih ni na seznamu. Ločite jih z vejico.",
        roles: "Primerne fractional vloge",
        roles_hint: "Vloge, ki bi jih prevzeli za del delovnega časa.",
        roles_empty: "Seznam vlog ni na voljo.",
        roles_other: "Druge vloge",
        roles_other_placeholder: "npr. Fractional Chief Data Officer",
        roles_other_info: "Za vloge, ki jih ni na seznamu. Ločite jih z vejico."
      },
      availability: {
        description: "Koliko časa ste na voljo in kje lahko delate.",
        days_per_month: "Število dni na mesec",
        days_per_month_placeholder: "npr. 8",
        days_per_month_info: "Delovni dnevi, ki jih lahko namenite enemu podjetju.",
        available_from: "Najzgodnejši možni začetek",
        available_from_placeholder: "dd.mm.llll",
        engagement_months_min: "Najkrajše trajanje angažmaja (mes.)",
        engagement_months_min_placeholder: "npr. 3",
        engagement_months_max: "Najdaljše trajanje angažmaja (mes.)",
        engagement_months_max_placeholder: "npr. 12",
        engagement_months_info: "V mesecih. Pustite prazno, če niste omejeni.",
        note: "Opomba glede razpoložljivosti",
        note_placeholder: "npr. Ob torkih in četrtkih nisem na voljo.",
        scope: "Geografski doseg",
        scope_placeholder: "Izberite doseg",
        scope_info: "Kako daleč ste pripravljeni redno potovati.",
        scopes: {
          local: "Lokalno",
          regional: "Regionalno",
          global: "Globalno"
        },
        work_modes: "Način dela",
        work_modes_hint: "Izberite vse načine, ki so za vas sprejemljivi.",
        modes: {
          onsite: "Na lokaciji",
          hybrid: "Hibridno",
          remote: "Na daljavo"
        },
        regions: "Regije",
        regions_placeholder: "Izberite regije",
        regions_info: "Regije, v katerih lahko delate na lokaciji.",
        relocate: "Pripravljen na selitev",
        relocate_hint: "Označite, če bi se za pravo priložnost preselili.",
        geography_note: "Opomba glede lokacije",
        geography_note_placeholder: "npr. Enkrat mesečno lahko potujem v tujino."
      },
      pricing: {
        description: "Cenovni okvir je opcijski in ni viden podjetjem.",
        daily_rate: "Dnevna tarifa",
        daily_rate_placeholder: "npr. 1200",
        daily_rate_info: "Neto tarifa za en delovni dan, brez DDV.",
        monthly_retainer: "Mesečni paket",
        monthly_retainer_placeholder: "npr. 6000",
        monthly_retainer_info: "Za dogovorjen obseg dni na mesec, brez DDV.",
        currency: "Valuta",
        currency_placeholder: "EUR",
        currency_info: "Tričrkovna oznaka valute, npr. EUR ali CHF.",
        negotiable: "Tarifa je pogajalska",
        note: "Opomba glede cene",
        note_placeholder: "npr. Za daljše angažmaje je tarifa nižja."
      },
      references: {
        description: "Izpostavite ključne delovne izkušnje ter dodajte nadzorne odbore in certifikate.",
        experiences: "Delovne izkušnje",
        experiences_hint: "Dodajte ali uredite izkušnje kar tukaj - shranijo se takoj in ločeno od profila.",
        highlighted: "Izpostavljene delovne izkušnje",
        highlighted_hint: "Označite tiste, ki jih naj podjetja vidijo najprej.",
        highlighted_empty: "Najprej dodajte delovno izkušnjo zgoraj.",
        highlighted_current: "danes",
        board_roles: "Izkušnje v nadzornih odborih",
        board_hint: "Članstva v nadzornih in upravnih odborih.",
        board_empty: "Dodajte prvo članstvo.",
        board_row: "članstvo",
        company: "Podjetje",
        company_placeholder: "npr. Acme d.o.o.",
        role: "Funkcija",
        role_placeholder: "npr. Predsednik nadzornega sveta",
        from: "Od",
        to: "Do",
        year_placeholder: "npr. 2019",
        year_info: "Vpišite samo letnico, npr. 2019.",
        to_placeholder: "npr. 2023",
        to_info: "Letnica ali \"danes\", če ste še član.",
        certificates: "Certifikati",
        certificates_hint: "Nazivi in certifikati, ki podpirajo vašo kredibilnost.",
        certificates_empty: "Dodajte prvi certifikat.",
        certificate_row: "certifikat",
        certificate_title: "Naziv certifikata",
        certificate_title_placeholder: "npr. ACCA",
        issuer: "Izdajatelj",
        issuer_placeholder: "npr. Združenje nadzornikov Slovenije",
        year: "Leto"
      },
      leadership: {
        description: "Stil vodenja in soft faktorji.",
        styles: "Stil vodenja",
        styles_hint: "Izberite vse, ki vas opišejo.",
        style_options: {
          hands_on: "Hands-on",
          strategic: "Strateški",
          coaching: "Coaching"
        },
        styles_other: "Drug stil vodenja",
        styles_other_placeholder: "npr. Servisno vodenje",
        culture_fit: "Kulturni fit",
        culture_fit_hint: "Okolja, v katerih ste najbolj učinkoviti.",
        culture_options: {
          corporate: "Korporativno",
          entrepreneurial: "Podjetniško"
        },
        culture_fit_other: "Drug kulturni fit",
        culture_fit_other_placeholder: "npr. Družinsko podjetje",
        motivation: "Motivacija za fractional delo",
        motivation_placeholder: "npr. Rad gradim finančne funkcije v podjetjih, ki si redno zaposlenega CFO še ne morejo privoščiti.",
        motivation_info: "Nekaj stavkov - to pogosto prebere naročnik pred prvim sestankom."
      }
    }
  }
}
